import _ from 'lodash';
import platformUtils from '../platformUtils';

function buildFullUrlFromMediaRef(mediaRef) {
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    const mediaItemUri = mediaSrcHandler.createMediaSrc({mediaId: mediaRef.videoId, type: mediaSrcHandler.types.VIDEO, title: mediaRef.fileName, width: mediaRef.posterImageRef.width, height: mediaRef.posterImageRef.height, posterId: mediaRef.posterImageRef.uri});
        if(mediaItemUri.error) {
            return null;
        }
    return mediaItemUri.item;
}

function extractModelDataFromSrc(src) {
    const backgroundUtils = platformUtils.getBackgroundUtils();
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    const parseMediaItem = mediaSrcHandler.parseMediaSrc(src, mediaSrcHandler.types.VIDEO);
    if (parseMediaItem.error) {
        return null;
    }

    return _.assign(backgroundUtils.getVideoPosterObject(parseMediaItem.mediaId, parseMediaItem.posterId, parseMediaItem.width, parseMediaItem.height), {fileName: parseMediaItem.title});
}

function getVideoId(videoId){
 return videoId.replace('video/', '');
}

function isVideoUrl(src){
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    return mediaSrcHandler.isValidMediaSrc(src, mediaSrcHandler.types.VIDEO);
}

function getFullVideoData(videoId, callback){
    videoId = getVideoId(videoId);
    const VIDEO_INFO_END_POINT = `https://files.wix.com/files/${videoId}/info`;
    fetch(VIDEO_INFO_END_POINT)
        .then((response) => response.json())
        .then((response) => {
            const backgroundUtils = platformUtils.getBackgroundUtils();
            const fullVideoMediaRef = backgroundUtils.getVideoBackgroundObject(response, {});
            callback(fullVideoMediaRef);
          });
}

export default {
    buildFullUrlFromMediaRef,
    isVideoUrl,
    extractModelDataFromSrc,
    getFullVideoData
};
